import {Component, OnInit, Input, OnChanges, SimpleChanges} from '@angular/core';
import {SwiperConfigInterface} from 'ngx-swiper-wrapper';
import {Router} from '@angular/router';
import {GoogleTagService} from '../../../../data/networking/services/shared/google-tag/google-tag.service';

@Component({
  selector: 'app-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent implements OnInit, OnChanges {
  @Input() arrayProducts;
  @Input() spaceDelete = 0;
  @Input() config: any;
  @Input() miniCard = false;
  @Input() isHome = false;
  @Input() idPrefix = '';
  @Input() origin = '';
  @Input() gtmList = '';
  @Input() gtmPreprocessor;
  @Input() navigation = true;
  @Input() rows = 1;
  @Input() dataLoaded = false;
  @Input() imagesOnly = false;
  @Input() videoOnly = false;
  @Input() ifAdvertisedModal = false;
  @Input() discountsLoaded = true;
  sendGtm = true;
  charge = false;
  configSwiper: SwiperConfigInterface;
  slideConfig: any;
  slicedProducts;
  lazyLoad = true;
  slidesPerView = {
    default: 3,
    xlg: 3,
    lg: 3,
    sm: 1.9,
    xsm: 1.9,
  };
  isMobile;

  constructor(private gtmService: GoogleTagService, private router: Router) {
    setTimeout(() => {
      this.configSwiper = {
        autoplay: false,
        direction: 'horizontal',
        slidesPerView: this.getSlidesPerView('default'),
        slidesPerColumn: this.rows,
        slidesPerGroup: this.getSlidesPerView('default'),
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        pagination: false,
        breakpoints: {
          1800: {
            slidesPerView: this.getSlidesPerView('xlg'),
            spaceBetween: 20,
            slidesPerGroup: (3 - this.spaceDelete),
          },
          1500: {
            slidesPerView: this.getSlidesPerView('lg'),
            spaceBetween: 0,
            slidesPerGroup: (3 - this.spaceDelete),
          },
          991: {
            slidesPerView: this.getSlidesPerView('sm'),
            slidesPerGroup: 1,
            spaceBetween: 0,
          },
          340: {
            slidesPerView: this.getSlidesPerView('xsm'),
            slidesPerGroup: 1,
            spaceBetween: 0,
          },
        },
      };
    }, 1000);
  }

  getSlidesPerView(prop) {
    for (const p in this.slidesPerView) {
      if (this.slidesPerView?.hasOwnProperty(p) && p === prop.toLowerCase()) {
        return this.slidesPerView[p] - this.spaceDelete;
      }
    }
    return null;
  }

  sliceArray() {
    if (this.arrayProducts) {
      const size = this.isMobile ? this.slidesPerView.sm : this.slidesPerView.lg;
      this.slicedProducts = this.arrayProducts.slice(0, size);
    }
  }

  ngOnInit() {
    this.charge = true;
    this.slideConfig = {...this.slideConfig, ...this.config};
    this.configSwiper = {
      autoplay: false,
      direction: 'horizontal',
      slidesPerView: this.getSlidesPerView('default'),
      slidesPerColumn: this.rows,
      slidesPerGroup: this.getSlidesPerView('default'),
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      pagination: false,
      breakpoints: {
        1800: {
          slidesPerView: this.getSlidesPerView('xlg'),
          spaceBetween: 5,
          slidesPerColumn: this.rows,
          slidesPerGroup: (5 - this.spaceDelete),
        },
        1500: {
          slidesPerView: this.getSlidesPerView('lg'),
          spaceBetween: 0,
          slidesPerColumn: this.rows,
          slidesPerGroup: (4.5 - this.spaceDelete),
        },
        991: {
          slidesPerView: this.getSlidesPerView('sm'),
          slidesPerGroup: 1,
          spaceBetween: 0,
          slidesPerColumn: this.rows,
          navigation: false,
        },
        340: {
          slidesPerView: this.getSlidesPerView('xsm'),
          slidesPerGroup: 1,
          spaceBetween: 0,
          slidesPerColumn: this.rows,
          navigation: false,
        },
      },
    };
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.sendGtm && changes
      && changes.arrayProducts
      && changes.arrayProducts.currentValue
      && changes.arrayProducts.currentValue.length > 0) {
      this.gtmService.onImpressions(changes.arrayProducts.currentValue, this.gtmList, this.gtmPreprocessor);
      this.sendGtm = false;
    }

    setTimeout(() => {
      this.charge = true;
    }, 1000);
  }

  goTo(item) {
    const title = (item.title) ? `-${this.urlFormatter(item.title)}` : '';
    const categorie = (item.categorie) ? `-${this.urlFormatter(item.categorie)}` : '';
    const urlGo = item.id + title + categorie;
    this.router.navigate(['/tutorial/', urlGo]);
  }

  urlFormatter = text => {
    if (!text) { return text; }
    return text.toLowerCase()
      .trim()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .replace(/´/g, '')
      .replace(/ /g, '-')
      .replace(/--/g, '-')
      .replace(/[&\/\\#,]/g, '')
      .replace(/[+()$~%.'"]/g, '')
      .replace(/[:=*?]/g, '')
      .replace(/[!<>{}]/g, '');
  }
}
